<template>
  <div
    class="step-container"
    :style="{ '--lineWidth': `${lineWidth}px`, '--right': `-${lineWidth}px` }"
  >
    <div
      :class="[
        'step-item',
        { 'step-item-next': index !== value.length - 1 },
        { 'step-item-active': index <= current },
      ]"
      :style="{
        marginRight: index !== value.length - 1 ? `${lineWidth}px` : '',
      }"
      :data-lineWidth="`${lineWidth}px`"
      v-for="(item, index) in value"
      :key="index"
    >
      <span class="step-item-no">{{ index + 1 }}</span
      >{{ item }}
    </div>
  </div>
</template>

<script>
export default {
  name: "navStepList",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    current: {
      type: Number,
      default: 0,
    },
    lineWidth: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style lang="less" scoped>
.step-container {
  display: flex;
  align-items: center;
  .step-item {
    min-width: 200px;
    display: flex;
    align-items: center;
    background-color: #999999;
    border-radius: 40px;
    padding: 10px 20px;
    font-size: 16px;
    font-weight: bold;
    color: #fff;
    position: relative;
    .step-item-no {
      color: #999999;
      font-size: 800;
      background-color: #fff;
      text-align: center;
      width: var(--lineWidth);
      height: 40px;
      line-height: 40px;
      border-radius: 50%;
      margin-right: 19px;
    }
  }
  .step-item-next {
    &::after {
      content: "";
      position: absolute;
      top: 50%;
      right: var(--right);
      transform: translateY(-50%);
      display: inline-block;
      width: var(--lineWidth);
      height: 2px;
      background-color: #e8e8e8;
    }
  }
  .step-item-active {
    background-color: #3992e9;
    transition: all 0.3s;
    .step-item-no {
      color: #3992e9;
    }
  }
}
</style>
